import CONST from "./Constant";

const INITIAL_STATE = {
    list:[],
    selected:{},
    preview:{}, // Theme being previewed (temporary)
    active:{}, // Currently active theme
    error: [],
    code: "",
    config:{
        from:0,
        to:0,
        lastPage:1,
        total:0,
        pagination:{
            page:0,
            pageSize:10,
        },
        filters:{
            keyword:'',
            sort_by:'created_at',
            sort_dir:'desc',
        }
    },
};

const Reducer = (state = INITIAL_STATE, action) => {

    switch (action.type){
        case CONST.SET_CONFIG:
            return {
                ...state,
                config: {
                    ...state.config,
                    ...action.payload
                },
            };
        case CONST.SET_SELECTED_ITEM:
            return {
                ...state,
                selected: state.list.find(item => item.id === action.payload) || {},
            }
        case CONST.SET_PREVIEW_THEME:
            return {
                ...state,
                preview: action.payload,
            }
        case CONST.SET_ACTIVE_THEME:
            return {
                ...state,
                active: action.payload,
                preview: {}, // Clear preview when theme becomes active
            }
        case CONST.CLEAR_PREVIEW:
            return {
                ...state,
                preview: {},
            }
        case CONST.FETCH_ITEM_SUCCESS:
            return {
                ...state,
                selected: action.payload.data,
                error: [],
                message: ["Themes loaded successfully"],
                code:action.payload.status,
            }
        case CONST.FETCH_ITEMS_SUCCESS:
            const paginate = action.payload.config.params.paginate
            return paginate === true ? {
                ...state,
                list:action.payload.data.data,
                config:{
                    ...state.config,
                    from:action.payload.data.from,
                    to:action.payload.data.to,
                    lastPage:action.payload.data.last_page,
                    total:action.payload.data.total,
                    pagination:{
                        ...state.config.pagination,
                        page:action.payload.data.current_page - 1,
                        pageSize:action.payload.data.per_page,
                    },
                },
                error: [],
                code:action.payload.status,
                message: ["Themes loaded successfully"],
            } : {
                ...state,
                list: action.payload.data,
                active: action.payload.data.find(theme => theme.is_active) || {},
                error: [],
                code:action.payload.status,
                message: ["Themes loaded successfully"],
            }
        case CONST.ADD_ITEM_SUCCESS:
            return {
                ...state,
                list:[...state.list,action.payload.data],
                selected: {},
                error: [],
                message: ["Themes added successfully"],
                code:action.payload.status,
            }
        case CONST.UPDATE_ITEM_SUCCESS:
            const indexU = state.list.findIndex(item => item.id === action.payload.data.id);
            return {
                ...state,
                list: [...state.list.slice(0, indexU), action.payload.data, ...state.list.slice(indexU + 1)],
                selected: action.payload.data,
                error: [],
                message: ["Themes updated successfully"],
                code:action.payload.status,
            }
        case CONST.DELETE_ITEM_SUCCESS:
            return {
                ...state,
                list:state.list.filter(item => item.id !== action.payload.data),
                selected: {},
                error: [],
                message: ["Themes deleted successfully"],
                code:action.payload.status,
            }
        case CONST.FETCH_ITEM_FAILED:
        case CONST.FETCH_ITEMS_FAILED:
        case CONST.ADD_ITEM_FAILED:
        case CONST.UPDATE_ITEM_FAILED:
        case CONST.DELETE_ITEM_FAILED:
            return {
                ...state,
                error: action.payload.data.errors,
                message: action.payload.data.message,
                code:action.payload.status,
            }
        default:
            return state;
    }
}

export default Reducer ;